import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
    selector: 'app-login',
    imports: [
        FormsModule,
    ],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent {
  @Input() loginEmail: string | undefined;
  @Input() registrationEmail: string | undefined;
  @Input() loginPassword: string | undefined;
  showLoginForm = true
  showRegisterPannel = false
  error: string | null = null;

  constructor(private auth: AuthService, private router: Router) { }

  onFormSubmission() {
    if (this.loginEmail && this.loginPassword) {
      this.auth.onLogin(this.loginEmail, this.loginPassword)
        .subscribe({
          next: login => {
          if (this.auth.isAuthenticated()) {
            this.router.navigate([login.redirect])
            this.error = null
          } else {
            this.error = "Not authenticated"
          }
        }, 
        error: error => { 
          console.log(error)
          this.error = error
        }
      })
    }
  }

  toggleForm() {
    this.showLoginForm = !this.showLoginForm
    this.showRegisterPannel = !this.showRegisterPannel
  }

  registerEmail() {
    console.log(this.registrationEmail)
    if (this.registrationEmail)
      this.auth.onRegister(this.registrationEmail).subscribe(()=> {
        console.log("Need to subscribe. This should show a success or something?")
      })
  }
}